import { serviceApi, withServiceRequestDefaults } from 'Shared/network';

export type ToggleActiveSnsAccountReq = {
  snsAccountUuid: string;
};

export const toggleActiveSnsAccount = async (req: ToggleActiveSnsAccountReq) => {
  const response = await serviceApi.snsAccount.toggleActiveViewupSnsAccount(
    withServiceRequestDefaults({
      snsAccountUuid: req.snsAccountUuid,
    }),
  );
  return response.data;
};
